import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BasePage } from "src/pages/base.page";
import FormatHelper from "projects/core/src/lib/core/FormatHelper";
import { CarteiraRecomendadaChangeItemModel } from "projects/core/src/lib/core/model/CarteiraRecomendadaChangeItemModel";
import { CarteiraRecomendadaAlteracaoPageViewModel } from "./CarteiraRecomendadaAlteracaoPageViewModel";
import { DataUtil } from "projects/core/src/lib/core/DataUtil";
import { IonContent } from "@ionic/angular";

@Component({
    selector: 'CarteiraRecomendadaAlteracaoPage',
    templateUrl: 'CarteiraRecomendadaAlteracaoPage.html',
    styleUrls: ['CarteiraRecomendadaAlteracaoPage.scss'],
})
export class CarteiraRecomendadaAlteracaoPage extends BasePage {
    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        super(router)
    }

    @ViewChild(IonContent) content: IonContent;

    changes: Array<CarteiraRecomendadaChangeItemModel>
    comentario: String
    dataMudanca: String
    historico = {snapshots: []}
    viewModel = new CarteiraRecomendadaAlteracaoPageViewModel()
    idCarteira

    ngOnInit() {
        const _self = this
        this.activatedRoute.queryParams.subscribe(params => {
            const data = JSON.parse(params.data)
            _self.getHistorico(data.idCarteira)
        })
    }

    async getHistorico(idCarteira) {
        this.historico = await this.viewModel.getHistorico(idCarteira)
        if (this.historico.snapshots.length > 0) {
            const item = this.historico.snapshots[0]
            this.clickItemHistory(item.details.changes, item.comentario, item.snapshot_date, false)
        }
    }

    clickItemHistory(changes, comentario, snapshot_date, scrollTo = true) {
        this.comentario = comentario
        this.dataMudanca = DataUtil.getDataHoraServidor(snapshot_date + " 00:00:00", DataUtil.EXPORT_DATE, "")
        this.changes = this.processaChanges(changes)
        if (scrollTo) {
            let el = document.getElementById("block-top")
            let offsetTop = el.offsetTop
            this.content.scrollToPoint(0, offsetTop - 10, 500)
        }
    }

    formataData(data) {
        return DataUtil.getDataHoraServidor(data + " 00:00:00", DataUtil.EXPORT_DATE, "")
    }

    processaChanges(changes: Array<any>): Array<CarteiraRecomendadaChangeItemModel> {
        changes.forEach(element => {
            element.alocacao_atual_str = FormatHelper.formatVariacao(element.alocacao_atual, false, 0)
            element.alocacao_anterior_str = FormatHelper.formatVariacao(element.alocacao_anterior, false, 0)
        });
        changes.sort((next, current) => {
            if (current.comment > next.comment) return -1;
            if (next.comment > current.comment) return 1;
            return 0;
        })
        return changes
    }
}